import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default function useMachineTypes() {
	const { t: $t } = useI18n()

	const machineTypesObj = computed(() => ({
		unknown: {
			title: $t('Unknown'),
			value: 'unknown'
		},
		tractor: {
			title: $t('Tractor'),
			value: 'tractor'
		},
		harvester: {
			title: $t('Harvester'),
			value: 'harvester'
		},
		sprayer: {
			title: $t('Sprayer'),
			value: 'sprayer'
		},
		loader:{
			title: $t('Loader'),
			value: 'loader'
		},
		auto: {
			title: $t('Car'),
			value: 'auto'
		},
		truck: {
			title: $t('Truck'),
			value: 'truck'
		},
		bus: {
			title: $t('Bus'),
			value: 'bus'
		},
		plane: {
			title: $t('Plane'),
			value: 'plane'
		},
		drone: {
			title: $t('Drone'),
			value: 'drone'
		},
		ship: {
			title: $t('Ship'),
			value: 'ship'
		},
		rain_machine: {
			title: $t('Rain machine'),
			value: 'rain_machine'
		},
		excavator: {
			title: $t('Excavator'),
			value: 'excavator'
		},
		grader: {
			title: $t('Grader'),
			value: 'grader'
		},
		truck_crane: {
			title: $t('Truck crane'),
			value: 'truck_crane'
		},
		tanker_truck: {
			title: $t('Tanker truck'),
			value: 'tanker_truck'
		},
		waste_dispenser: {
			title: $t('Waste dispenser'),
			value: 'waste_dispenser'
		},
		gasoline_tanker: {
			title: $t('Gasoline tanker'),
			value: 'gasoline_tanker'
		},
		bulldozer: {
			title: $t('Bulldozer'),
			value: 'bulldozer'
		},
		water_carrier: {
			title: $t('Water carrier'),
			value: 'water_carrier'
		},
		grapple: {
			title: $t('Grapple'),
			value: 'grapple'
		},
		crawler_tractor: {
			title: $t('Crawler tractor'),
			value: 'crawler_tractor'
		},
		compressor: {
			title: $t('Compressor'),
			value: 'compressor'
		},
		chemistry_machine: {
			title: $t('Chemistry machine'),
			value: 'chemistry_machine'
		},
		minibus: {
			title: $t('Minibus'),
			value: 'minibus'
		},
		miniloader: {
			title: $t('Miniloader'),
			value: 'miniloader'
		},
		fire_engine: {
			title: $t('Fire engine'),
			value: 'fire_engine'
		},
		self_propelled_header: {
			title: $t('Self propelled header'),
			value: 'self_propelled_header'
		},
}))

	return {
		machineTypes: computed(() => Object.values(machineTypesObj.value)),
		machineTypesObj,
	}
}
